var _circle, _circle2, _circle3, _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBadSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.25,
    fill: "#FECA63",
    stroke: "#373A4D",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 16,
    r: 2,
    fill: "#373A4D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 16,
    r: 2,
    fill: "#373A4D"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_1059_7642",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1992 30C11.1258 25.4355 15.1613 22 19.9992 22C24.8371 22 28.8726 25.4355 29.7991 30H28.2626C27.3631 26.2706 24.0047 23.5 19.9992 23.5C15.9936 23.5 12.6352 26.2706 11.7358 30H10.1992Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 30V31.5H8.36414L8.7292 29.7016L10.1992 30ZM29.7991 30L31.2692 29.7016L31.6342 31.5H29.7991V30ZM28.2626 30V31.5H27.0813L26.8044 30.3517L28.2626 30ZM11.7358 30L13.194 30.3517L12.9171 31.5H11.7358V30ZM8.7292 29.7016C9.79485 24.4518 14.4338 20.5 19.9992 20.5V23.5C15.8887 23.5 12.4567 26.4192 11.6692 30.2984L8.7292 29.7016ZM19.9992 20.5C25.5645 20.5 30.2035 24.4518 31.2692 29.7016L28.3291 30.2984C27.5417 26.4192 24.1097 23.5 19.9992 23.5V20.5ZM29.7991 31.5H28.2626V28.5H29.7991V31.5ZM19.9992 22C24.7136 22 28.6626 25.2609 29.7207 29.6483L26.8044 30.3517C26.0637 27.2804 23.2959 25 19.9992 25V22ZM10.2776 29.6483C11.3357 25.2609 15.2848 22 19.9992 22V25C16.7025 25 13.9347 27.2804 13.194 30.3517L10.2776 29.6483ZM11.7358 31.5H10.1992V28.5H11.7358V31.5Z",
    fill: "#373A4D",
    mask: "url(#path-4-inside-1_1059_7642)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBadSelected);
export default __webpack_public_path__ + "static/media/ic_bad_selected.dbcd11916c4415578f0b7bf87f59a084.svg";
export { ForwardRef as ReactComponent };